<section class="child">
    <c-tree-explorer config="vm.shortcutConfig"></c-tree-explorer>
</section>